import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { DashboardEnergyValueFlowContainer } from '@hems/container';
import { MainTitle } from '@/components';
export default defineComponent({
    name: 'Home',
    components: {
        MainTitle,
        DashboardEnergyValueFlowContainer,
    },
    async setup() {
        const store = useStore();
        const show = ref(false);
        const baseDeviceInfo = computed(() => store.state.device.baseDeviceInfo ?? null);
        const siteConfigurationInfo = computed(() => store.state.device.siteConfiguration ?? null);
        const isConsumptionCT = computed(() => store.state.device.isConsumptionCT);
        return {
            show,
            baseDeviceInfo,
            siteConfigurationInfo,
            isConsumptionCT,
        };
    },
});
